/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type OrgSettingsPutConsentCollection = typeof OrgSettingsPutConsentCollection[keyof typeof OrgSettingsPutConsentCollection] | null;


export const OrgSettingsPutConsentCollection = {
  email: 'email',
  in_meeting: 'in_meeting',
  manual: 'manual',
  disabled: 'disabled',
} as const;
